import ObjectID from 'bson-objectid';
import { registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';

export function IsMongoIdObject(validationOptions?: ValidationOptions) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: 'IsMongoIdObject',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown, _args: ValidationArguments) {
          return typeof value === 'string' && /^[a-fA-F0-9]{24}$/.test(value) && ObjectID.isValid(value);
        },
        defaultMessage(): string {
          return 'Invalid Mongo ObjectId';
        },
      },
    });
  };
}
